import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { WarehouseInventory } from '../entities/warehouse-inventory';



export class WarehouseInventoryRequest extends BaseRequest {
    warehouseInventory : WarehouseInventory;
}

